module.exports = "/fonts/fa-regular-400.woff2?7980a6361c25b4665dbbe92d4488783c";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-regular-400.woff2
// module id = 2zlX
// module chunks = 0 1